import type { GetNotificationsResult } from "api-contracts/rpc/notifications";
import { resolve } from "../di";
import type { IAuthState } from "../services/auth/types";
import { queryOptions } from "../query-options";
import { rpc } from "../services/rpc";

export const notificationsQueryKey = "get-notifications";

export const notificationsQueryOptions = queryOptions<GetNotificationsResult | null>({
  queryKey: [notificationsQueryKey],
  queryFn: async (): Promise<GetNotificationsResult | null> => {
    const authState = resolve<IAuthState>("authState");
    await authState.ready;
    if (!authState.isAuthenticated.get()) return null;
    return rpc<typeof notificationsQueryKey>(notificationsQueryKey, { limit: "50" });
  },
});
